import {
	Component,
	ChangeDetectionStrategy,
	input,
	ViewEncapsulation,
} from '@angular/core';

@Component({
	selector: 'skl-toast',
	template: `
		<output>
			<slot name="start"></slot>
			<slot></slot>
			<slot name="end"></slot>
		</output>
	`,
	styles: `
		:host {
			--toast-surface : var(--surface-2-color);
			--toast-text-color: var(--text-1);
			--grainy-background: url('data:image/svg+xml,<!-- svg: first layer --><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><filter id="noiseFilter"><feTurbulence type="fractalNoise" baseFrequency="2.9" numOctaves="2" stitchTiles="stitch"/></filter><rect width="100%" height="100%" filter="url(%23noiseFilter)"/></svg>');

			position: relative;
			color: color-mix(in oklch, var(--toast-text-color), oklch(59% 0 187));
			background-color: color-mix(in oklch, var(--toast-surface), transparent 20%);
			backdrop-filter: blur(30px) saturate(180%);
			-webkit-backdrop-filter: blur(30px) saturate(180%);
			padding: 1rem;
			border-radius: .5rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			pointer-events: all;
			user-select: none;
			overflow: clip;
			box-shadow:
				0 2px 5px hsl(0deg 0% 0% / 30%),
				inset 0 0 0 1px hsl(0deg 0% 100% / 10%);

			&::after {
				content: '';
				position: absolute;
				inset: 0;
				height: 100%;
				width: 100%;
				background: linear-gradient(to top, color-mix(in oklch, var(--toast-text-color), transparent 95%) 0%, transparent 100%);
				z-index: -1;
			}

			&::before {
				content: '';
				position: absolute;
				inset: 0;
				height: 100%;
				width: 100%;
				opacity: 4%;
				background-image: var(--grainy-background);
				background-size: 100px 100px;
				z-index: -1;
			}

			output {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 1rem;
				flex: 1;
			}
		}

		:host([type="success"]) {
			--toast-text-color: var(--success-color);
		}

		:host([type="warning"]) {
			--toast-text-color: var(--warning-color);
		}

		:host([type="error"]) {
			--toast-text-color: var(--error-color);
		}

		:host([type="info"]) {
			--toast-text-color: var(--info-color);
		}

		::slotted(*) {
			text-box: trim-both cap alphabetic;
		}
	`,
	host: {
		'[attr.type]': 'type()',
	},
	encapsulation: ViewEncapsulation.ShadowDom,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
	readonly type = input<string>('info');
}
